import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { isCheckboxSelected, toggleCheckbox } from '../utils/utils'
import { selectDay } from 'shared/service/helpers/DateUtilities'

interface IProps {
  disabled: boolean
}

const DayControl: FC<IProps> = ({ disabled }) => {
  const { control } = useFormContext<IKlantGroepModel>()

  return (
    <Controller
      control={control}
      name='dagen'
      render={({ field }) => {
        const days = [1, 2, 3, 4, 5, 6, 0]
        const allSelected = days.every(d => isCheckboxSelected(field.value, d))
        const toggleAll = () => {
          if (allSelected) {
            field.onChange('') // Deselect all
          } else {
            field.onChange(days.join(',')) // Select all
          }
        }
        return (
          <div className='row'>
            <div className='col-10'>
              <div className='row'>
                {days.map(day => (
                  <div key={day}>
                    <div
                      className='col pr-0'
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <label htmlFor={`day-${day}`}>{selectDay(day)}</label>
                      <input
                        type='checkbox'
                        id={`day-${day}`}
                        checked={isCheckboxSelected(field.value, day)}
                        disabled={disabled}
                        onChange={() =>
                          field.onChange(toggleCheckbox(field.value, day))
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className='col-2'
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <label htmlFor='day-all'>alle</label>
              <input
                type='checkbox'
                id='day-all'
                checked={allSelected}
                disabled={disabled}
                onChange={toggleAll}
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default DayControl
